// hooks/useHistoryHandler.js
import { useCallback } from 'react';

export const useHistoryHandler = ({
    filters,
    updateFilters,
    fetchSemanticRCA,
    fetchSemanticRCA2,
    UserData,
    fetchCategories,
    setTotalCounts,
    setIsLoading
}) => {
    const handleHistoryClick = useCallback(async (historyItem) => {
        setIsLoading(true);
        try {
            const { params } = historyItem;
            console.log(params);
            let categoryData = [];
            updateFilters({
                query: params.query,
                startDate: new Date(params.start_date),
                endDate: new Date(params.end_date),
                threshold: params.threshold,
                value: params.value,
                complaintNumbers: params.complaint_numbers
            });

            const data = await fetchSemanticRCA2({
                ...filters,
                complaintNumbers: params.complaint_numbers,
                query: params.query,
                value: params.value,
                threshold: params.threshold,
                startDate: new Date(params.start_date),
                endDate: new Date(params.end_date)
            });

            categoryData = [
                params.query,
                {
                    prompt: params.prompt,
                    total_counts: params.total_counts,
                    complaintNumbers: params.complaint_numbers
                }
            ]

            const newFilters = {
                ...filters,
                query: params.query,
                startDate: new Date(params.start_date),
                endDate: new Date(params.end_date),
                threshold: params.threshold,
                value: params.value,
                complaintNumbers: params.complaint_numbers
            };

            UserData(data?.complaintNumbers || ["NA"]);
            await fetchCategories(categoryData, newFilters);
            setTotalCounts(params.total_counts || 0);
        } catch (error) {
            console.error('Error loading history item:', error);
        } finally {
            setIsLoading(false);
        }
    }, [
        filters,
        updateFilters,
        fetchSemanticRCA,
        fetchSemanticRCA2,
        UserData,
        fetchCategories,
        setTotalCounts,
        setIsLoading
    ]);

    return { handleHistoryClick };
};